import React from 'react';
import { Form, Formik, Field } from 'formik';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, FormRow, FileUpload, TagsInput } from '../controls';

const VendorSchema = Yup.object().shape({
  vendorName: Yup.string().required('Vendor name is required'),
  category: Yup.string().required('Category is required'),
});

export function VendorForm({
  vendor,
  vendorCategories,
  onFileUpload,
  onFileDelete,
  handleSave,
}) {
  const saveVendor = (values) => {
    const { vendorId } = vendor;
    const category = values.category ? values.category : '';
    const subcategory = values.subcategory ? values.subcategory : '';
    const payload = { ...values, category, subcategory, vendorId };

    handleSave(payload);
  };

  const defaultLinks = {
    instagram: '',
    twitter: '',
    facebook: '',
    web: '',
  };

  const defaultCategory = vendor ? [vendor.category] : null;
  const defaultSubcategory = vendor ? [vendor.subcategory] : null;
  const defaultValues = {
    vendorName: vendor ? vendor.vendorName || '' : '',
    vendorContact: vendor ? vendor.vendorContact || '' : '',
    vendorDescription: vendor ? vendor.vendorDescription || '' : '',
    links: vendor ? vendor.links || defaultLinks : defaultLinks,
  };

  const categories = vendorCategories.categories || [];
  const subcategories = vendorCategories.subcategories || [];

  if (defaultCategory) {
    defaultValues.category = defaultCategory[0];
  } else {
    defaultValues.category = null;
  }

  if (defaultSubcategory) {
    defaultValues.subcategory = defaultSubcategory[0];
  }

  const fileList = [];

  if (vendor && vendor.photoURL) {
    fileList.push({
      uid: '-1',
      name: vendor.vendorPhoto,
      url: vendor.photoURL,
      status: 'done',
    });
  }

  return (
    <Formik
      enableReinitialize
      initialValues={defaultValues}
      onSubmit={saveVendor}
      validationSchema={VendorSchema}
    >
      {() => (
        <Form>
          <div className="flex">
            <div className="w-3/4 p-4">
              <FormRow label="Vendor Name" errorName="vendorName">
                <Field type="text" name="vendorName" placeholder="Name" />
              </FormRow>
              <FormRow label="Contact">
                <Field type="text" name="vendorContact" placeholder="Contact" />
              </FormRow>
              <FormRow label="Category" errorName="category">
                <Field
                  name="category"
                  render={({ field, form: { setFieldValue } }) => (
                    <TagsInput
                      value={field.value}
                      placeholder="Select or enter a category"
                      options={categories}
                      onChange={(v) => setFieldValue('category', v)}
                    />
                  )}
                />
              </FormRow>
              <FormRow label="Subcategory">
                <Field
                  name="subcategory"
                  render={({ field, form: { setFieldValue } }) => (
                    <TagsInput
                      value={field.value}
                      placeholder="Select or enter a subcategory"
                      options={subcategories}
                      onChange={(v) => setFieldValue('subcategory', v)}
                    />
                  )}
                />
              </FormRow>
            </div>
            <div className="w-1/4 p-4">
              <FormRow>
                <div className="w-full">
                  <FileUpload
                    fileList={fileList}
                    onFileUpload={onFileUpload}
                    onFileDelete={onFileDelete}
                  />
                </div>
              </FormRow>
            </div>
          </div>
          <FormRow label="Description">
            <Field
              component="textarea"
              name="vendorDescription"
              placeholder="Vendor Description..."
            />
          </FormRow>
          <FormRow label={<FontAwesomeIcon icon={['fas', 'globe']} />}>
            <Field type="text" name="links.web" placeholder="Website" />
          </FormRow>
          <FormRow label={<FontAwesomeIcon icon={['fab', 'facebook']} />}>
            <Field type="text" name="links.facebook" placeholder="Facebook" />
          </FormRow>
          <FormRow label={<FontAwesomeIcon icon={['fab', 'twitter']} />}>
            <Field type="text" name="links.twitter" placeholder="Twitter" />
          </FormRow>
          <FormRow label={<FontAwesomeIcon icon={['fab', 'instagram']} />}>
            <Field type="text" name="links.instagram" placeholder="Instagram" />
          </FormRow>
          <Button className="float-right mt-4" mode="dark">
            Save Vendor
          </Button>
        </Form>
      )}
    </Formik>
  );
}
